import { LocalProgressStore } from "./LocalProgressStore";
import type { ProgressStore } from "./ProgressStore";

/**
 * Zentrale Instanz des Fortschrittsspeichers. Sobald es Benutzerkonten gibt,
 * wird hier auf eine serverbasierte Implementierung umgestellt.
 */
export const progressStore: ProgressStore = new LocalProgressStore();

export * from "./ProgressStore";
